var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6218 34.0217V22.3873H27.5275L28.1119 17.8537H23.6203V14.959C23.6203 13.6461 23.9854 12.7508 25.8691 12.7508H28.2696V8.69488C27.1071 8.56998 25.9386 8.5098 24.7695 8.51462C21.3085 8.51462 18.9395 10.6282 18.9395 14.5083V17.8537H15.0218V22.3873H18.938V34.0217H4.6628C3.74647 34.0217 3.00439 33.2796 3.00439 32.3632V5.63644C3.00439 4.72011 3.74647 3.97803 4.6628 3.97803H31.3896C32.3059 3.97803 33.048 4.72011 33.048 5.63644V32.3632C33.048 33.2796 32.3059 34.0217 31.3896 34.0217H23.6218Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.614fb91ab709b069780664be96974ea5.svg";
export { ForwardRef as ReactComponent };